import { Component, OnInit, Inject, Input, HostListener, ViewChild, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { LookupInfo } from '../model/lookup.model';
import { EmpInfo } from '../model/emp.model';
import { IssueInfo } from '../model/issue.model';
import { IssueManagementComponent, summaryInfo, summarydetailInfo } from '../issue-management/issue-management.component'; //Add from lesson learned tab
import { GanttChartControlComponent } from "../gantt-chart-control/gantt-chart-control.component";
import { RoleInfo } from '../model/role.model';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { async } from '@angular/core/testing';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { Dictionary } from '@fullcalendar/angular';
import { JobInfo } from '../model/Job.model';
import { EffortPlanInfo, EffortPlanTransferInfo, EffortPlanViewInfo } from '../model/effortplan.model';
import { EffortInfo } from '../model/effort.model';
import { Key } from 'protractor';
import { DatePipe, formatDate } from '@angular/common';
import { ReportEffortPlanProjectInfo, ReportEffortPlanProjectViewInfo } from '../model/reportEffortPlanProject.model';
import { ProjectMemberInfo } from '../model/projectmember.model';

let today = new Date().toISOString()

@Component({
  selector: 'app-project-effort-estimation',
  templateUrl: './project-effort-estimation.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./project-effort-estimation.component.css']
})


export class ProjectEffortEstimationComponent implements OnInit {
  @ViewChild(GanttChartControlComponent) ganttchart;
  @Input() ViewMode: boolean = false;

  ReportView: ReportEffortPlanProjectInfo[];
  ListEmployeeCode: string[] = [];

  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;
  ProjectList: ProjectInfo[]
  EffortPlanList: EffortPlanInfo[]
  groupedPlanData: EffortPlanInfo[]
  groupedPlanDataList: EffortPlanInfo[]
  uniqueKeys: number[]
  uniqueMonth: number[][]
  countKey: number
  formattedMonths: string[] = [];

  _ParamProjectCode: string
  _ParamEffortGroupName: string
  _ParamEffortGroupType: string
  _ParamEffortGroupId: number
  _ParamSaleEffortGroupId: number
  isImport: boolean;
  minEffortMonthYear: string | null = null;

  titlemodal: string
  detailmodal: string

  txtProjectCode: string
  txtProjectName: string
  txtProjectStart: string
  txtProjectEnd: string
  ddlProjectStatus: string
  ddlProjectStatusSavedraft: string

  ProjectTotal: any
  isOnUpdate: boolean;

  element: HTMLElement;
  public hidcouchk: string;

  txtProjectComment: string;

  ddlSupportContractType: string = null;
  ddlWarrantyType: string = null;
  ddlMAType: string = null;
  txtWarrantyStartDate: string = null;
  txtWarrantyEndDate: string = null;
  txtMAStartDate: string = null;
  txtMAEndDate: string = null;
  ddlPackage: number = null;
  strValue: string = "Y";

  SupportContractTypeList: any;
  WarrantyTypeList: any;
  MATypeList: any;
  ProjectPackageList: any;

  issueListAll: IssueInfo[]
  IssuePromise: Promise<IssueInfo[]>
  summaryInfo = new summaryInfo;


  IssueSummaryTotal: any

  lblbaselinestartdate: string;
  lblbaselineenddate: string;
  lblbaselinetotaldays: number;
  lblactualstartdate: string;
  lblactualenddate: string;
  lblactualtotaldays: number;
  lbloverduedays: number;
  totalticket: number;
  RoleCode: string;

  //Import Plan
  txtSchYear: string = "";
  txtSchFormat: string = "1";

  inlineCheckboxBaselinePlan: boolean
  inlineCheckboxActualPlan: boolean
  SelectPlan: string = 'baseline,actual,';
  public TabProjectPlanIndex = 1;
  public TabOrganizationalIndex = 1;

  Stagelist: any;
  Actionlist: any;

  // Form Group
  //ProjectDetailForm: FormGroup;

  // array control
  itemsSetup: FormArray;
  itemsSetting: FormArray;
  itemsGetting: FormArray;
  itemsBaseline: FormArray;
  selectType: LookupInfo[];
  selectEmpName: EmpInfo[];
  selectRole: RoleInfo[];

  ActualList: EffortPlanInfo[];
  ActualTimeList: EffortPlanInfo[];

  GroupEffort: Promise<EffortPlanInfo[]>

  dynamicObject: any[];
  objectKeys: string[];
  dynamicDict: { [key: string]: any }[];


  /******************************* Variables ********************************/
  @Input() ProjectId: string;
  @Input() ProjectCode: string;

  baseurl: string;
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';

  filteredOptions: Observable<string[]>;
  isSubmitted: any;
  CurrentTabSelected: string;
  UserRole: string;

  IsShowForThisUser: boolean;
  IsShowForThisUserOther: boolean;
  IsShowForThisUserOtherManager: boolean;
  IsShowVersion: boolean;

  hidProjectId: number

  //Pagination variable
  //public currentPageNumber: number
  //public totalPages: number
  //public environment: number

  //Pagination
  indexNo: number = 0
  currentPageNumber: number = 1;
  totalTeams: number = 0;
  totalPages: number = 0;
  pageSize: number = 10;


  //empselect
  employeeselectrun: boolean = false;
  employeeselectreturnto: number;
  selectedemp: EmpInfo;
  rolefiltermodal: string = '';
  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;

  ListEffortPlan: EffortPlanInfo[] = [];
  ListEffortPlanSale: EffortPlanInfo[] = [];
  ListPosition: JobInfo[] = [];

  //ListMonth: { id: number, monthYear: string }[] = [];
  ListMonth = [];
  ListMonthSale = [];

  reload: boolean = true;
  valuechange: boolean = false;

  //ETC
  numberList: number[] = Array.from({ length: 1000 }, (_, i) => i + 1);
  selectedETC: string;


  validateDelivery: boolean = false;
  plancount: number = 0;

  transferEmp: boolean = false;
  transferEmpSelectStep: boolean = false;
  transferEmpConfirmStep: boolean = false;
  effortPlanCurrent: EffortPlanInfo;
  ListEffortPlanTransfer: EffortPlanInfo[] = [];
  viewTransferHistory: boolean = false;

  EmployeeList: EmpInfo[] = [];
  AssignMemberLeadList: ProjectMemberInfo[] = [];
  itemsAssignMemberForm_array: FormArray;

  /******************************* Variables ********************************/


  /******************************* Functions ********************************/
  //Constructor
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, 
   private activatedRoute: ActivatedRoute, private TokenService: TokenService, private cdr: ChangeDetectorRef, private router: Router) {
    this.baseurl = environment.base_api;
  }

  //Initial data
  async ngOnInit() {
    //this.currentPageNumber = 1;
    //this.environment = environment.PageSize;
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSize;
    this.UserRole = localStorage.getItem("EmpRoleCode");
    this.IsShowForThisUser = (this.UserRole != "CUSTOMER");
    this.IsShowForThisUserOther = (this.UserRole == "CUSTOMER");
    this.IsShowForThisUserOtherManager = (this.UserRole == "MANAGER" || this.UserRole == "PROJECTCO" || this.UserRole == "PROJDIRECTOR" || this.UserRole == "DIRECTOR" || this.UserRole == "SALEDIRECTOR" || this.UserRole == "SALEMANAGER");
    this.IsShowVersion = false;
    this.CurrentTabSelected = 'Sale';
    this.TabProjectPlanIndex = 1;
    this.SetSelectTabProject(1);
    this.SetSelectTabOrganizational(1);
    this.RoleCode = localStorage.getItem('EmpRoleCode');
    this._ParamProjectCode = this.GetParam('ProjectCode').toString();
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
    //this.currentPageNumber = 1;

    //this.loadEffortPlanList();

    await this.getPlanListGroup();

    (await this.LoadTabSale().then((data) => {
      this.ListEffortPlanSale = data;
      this.ListMonthSale = this.getMaxMonthSale()
      // Iterate through ListEffortPlan
      this.ListEffortPlanSale.forEach((effortPlan) => {
        // Iterate through ListEffort of each EffortPlan
        effortPlan.ListEffort.forEach((effortInfo) => {
          // Check if EffortMonthYear is missing
          if (!effortInfo.EffortMonthYear) {
            // Find the matching ListMonth item based on id
            const matchingMonth = this.ListMonthSale.find((month) => month.id === effortInfo.EffortMonth);

            // If a matching month is found, add EffortMonthYear
            if (matchingMonth) {
              effortInfo.EffortMonthYear = matchingMonth.monthYear;
            }
          }

          console.log('SALELOAD')
          console.log(this.minEffortMonthYear)

          const effortMonthYear = effortInfo.EffortMonthYear;
          if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
            this.minEffortMonthYear = effortMonthYear;
          }
        });
      });
    }));

    // Delivery Tab
    (await this.LoadEffortPlanDelivery().then((data) => {
      console.log("LoadEffortPlanDelivery === ", data);

      this.ListEffortPlan = data;
      // Iterate through ListEffortPlan
      this.ListEffortPlan.forEach((effortPlan) => {
        // Iterate through ListEffort of each EffortPlan
        effortPlan.ListEffort.forEach((effortInfo) => {
          // Check if EffortMonthYear is missing
          if (!effortInfo.EffortMonthYear) {
            // Find the matching ListMonth item based on id
            const matchingMonth = this.ListMonth.find((month) => month.id === effortInfo.EffortMonth);

            // If a matching month is found, add EffortMonthYear
            if (matchingMonth) {
              effortInfo.EffortMonthYear = matchingMonth.monthYear;
            }
          }

          console.log('PROJLOAD')
          console.log(this.minEffortMonthYear)

          const effortMonthYear = effortInfo.EffortMonthYear;
          if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
            this.minEffortMonthYear = effortMonthYear;
          }
        });
      });
    }));

    console.log(this.ListMonth)

    this.loadEffortPlanList().then(data => {
      this.groupedPlanDataList = data;
      if (this.groupedPlanDataList.length > 0) {
        this._ParamEffortGroupName = this.groupedPlanDataList[0].EffortGroupName;
        this._ParamEffortGroupType = this.groupedPlanDataList[0].ProjectType;
        this._ParamEffortGroupId = this.groupedPlanDataList[0].EffortGroupId;

        this.ListMonth = this.getMaxMonth()

        // Iterate through ListEffortPlan
        this.ListEffortPlan.forEach((effortPlan) => {
          // Iterate through ListEffort of each EffortPlan
          effortPlan.ListEffort.forEach((effortInfo) => {
            // Check if EffortMonthYear is missing
            if (!effortInfo.EffortMonthYear) {
              // Find the matching ListMonth item based on id
              const matchingMonth = this.ListMonth.find((month) => month.id === effortInfo.EffortMonth);

              // If a matching month is found, add EffortMonthYear
              if (matchingMonth) {
                effortInfo.EffortMonthYear = matchingMonth.monthYear;
              }
            }

            const effortMonthYear = effortInfo.EffortMonthYear;
            if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
              this.minEffortMonthYear = effortMonthYear;
            }
          });
        });

      } else {
        this._ParamEffortGroupName = null;
        this._ParamEffortGroupType = null;
        this._ParamEffortGroupId = null;
      }
    });

    this.LoadPosition().then((data) => {
      this.ListPosition = data;
    });

    this.loadEmp();
    // End Delivery Tab

    await this.LoadReport();
  }

  async saveAssignMember(): Promise<boolean> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) return false;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    // debugger;
    if (!this.EmployeeList || this.EmployeeList.length === 0) {
      await this.loadEmpList();
    }
    const arrayinsert = this.ListEffortPlan.map((itemcurrent) => {
      const emp = this.EmployeeList.find(x => x.EmpCode === itemcurrent.EffortPlanEmpCode);
      return {
        ProjectCode: this._ParamProjectCode,
        ProjectType: "Project",
        EmpCode: itemcurrent.EffortPlanEmpCode,
        EmpRole: emp ? emp.RoleCode : '',
        FlagRemoveAssignMemberFromClient: false,
        UpdateBy: this.checkUndefinedString(localStorage.getItem("EmpCode"))
      };
    });

    const strjson = JSON.stringify(arrayinsert);

    try {
      await this.httpClient.post<any>(this.baseurl + "ProjectMember/UpdateAssignMemberProjectEstimate", strjson, httpOptions).toPromise();
      console.log("SaveAssignMember success");
      return true;
    } catch (error) {
      console.error("SaveAssignMember failed", error);
      return false;
    }
  }


  async loadEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteriaNotResign", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emplist for assign member without cuurent manager && member is internal
          this.EmployeeList = data;

          // load detail emp for assign member

          this.AssignMemberLeadList.forEach((traget, indextraget) => {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMember(traget));
            //load detail of Emp
            this.onChanges(indextraget)
          });
        });
    }
  }

  createItemAssignMember(ProjectMemberitem: ProjectMemberInfo): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [ProjectMemberitem.Id],
      EmpName: [ProjectMemberitem.EmpCode, Validators.required],
      EmpNameDisplay: [ProjectMemberitem.EmpNameDisplay],
      PositionInProject: [''],
      PositionInProjectDisplay: [''],
      JobTitle: [''],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }

  //Events function
  OnSelectedTabChange(traget) {
    //Collect current tab
    this.CurrentTabSelected = traget.tab.textLabel;

    //}

    this._selectLoader(traget.tab.textLabel);

    this.btnClick_reload();
  }
  

  OnUploadTypeChange(selectedValue) {
    switch (selectedValue) {
      case "create":
        $('#FileNameUpdatePanel').addClass('d-none');
        $('#FileNameCreatePanel').removeClass('d-none');
        $('#txtFileVersion').text("-")
        break;
      case "update":
        $('#FileNameUpdatePanel').removeClass('d-none');
        $('#FileNameCreatePanel').addClass('d-none');
        break;
      default:
        $('#FileNameUpdatePanel').addClass('d-none');
        $('#FileNameCreatePanel').removeClass('d-none');
        $('#txtFileVersion').text("-")
        break;
    }
  }

  // Function to calculate the sum of a specific column by its key
  calculateColumnSum(key: string): number {
    let sum = 0;
    if (this.dynamicObject) {
      for (const row of this.dynamicObject) {
        if (row.hasOwnProperty(key) && !isNaN(row[key])) {
          sum += +row[key];
        }
      }
    }
    return sum;
  }

  SetSelectTabProject(tabCount: number) {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % tabCount;
  }

  SetSelectTabOrganizational(tabCount: number) {
    this.TabOrganizationalIndex = (this.TabOrganizationalIndex + 1) % tabCount;
  }

  private _selectLoader(tabSelectedKey: string) {


    this.loadEffortPlanList();
  }



  /******************************* Functions ********************************/
  btnClick_showProjectList() {
    //this.LoadProject()
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectDocument"]').prop('checked', check);

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

  async getPlanListGroup(){
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = this.CurrentTabSelected;
      let strjson = JSON.stringify(objectjson);

       await this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "ProjectEffortPlan/GetProjectEffortPlan", strjson, httpOptions)
        .subscribe((data) => {
          this.groupedPlanData = data; // Assign fetched data to the 'data' property
          this._ParamEffortGroupName = this.groupedPlanData[0].EffortGroupName;
          this._ParamEffortGroupType = this.groupedPlanData[0].ProjectType;
          this._ParamEffortGroupId = this.groupedPlanData[0].EffortGroupId;
          this._ParamSaleEffortGroupId = this.groupedPlanData[0].EffortGroupId;
          this.uniqueKeys = Array.from(new Set(this.groupedPlanData.map((item) => item.EffortPlanId)));
          this.countKey = this.uniqueKeys.length;

          this.uniqueMonth = Array.from(
            new Set(
              [].concat(
                ...this.groupedPlanData.map((item) =>
                  item.ListEffort.map((o) => o.EffortMonth)
                )
              )
            )
          );
          
        });
      
    }
  }

  async loadEffortPlanList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = "DELIVERY";
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "ProjectEffortPlan/GetProjectEffortPlan", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadTabSale() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = "SALE";
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "ProjectEffortPlan/GetEffortPlanSale", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadEffortPlanDelivery() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      //objectjson["EffortGroupId"] = this._ParamEffortGroupId;
      objectjson['ProjectSaleCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = "DELIVERY";

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "EffortGroup/GetEffortPlan", strjson, httpOptions)
        .toPromise()
    }
  }

  async SaveEffortPlan() {
    //debugger
    const saveMemberResult = await this.saveAssignMember();
    if (!saveMemberResult) return false;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let param = new EffortPlanViewInfo();

      if (this.ListEffortPlan == null || this.ListEffortPlan.length <= 0) {
        param.DeletePlanGroupId = this._ParamEffortGroupId
      } else {
        param.ListEffortPlan = this.ListEffortPlan;

        param.ListEffortPlan[0].ProjectSaleCode = this._ParamProjectCode;
        param.ListEffortPlan[0].ProjectType = 'DELIVERY';
      };

      let strjson = JSON.stringify(param);

      return await this.httpClient.post<boolean>(this.baseurl + "EffortGroup/SaveEffortPlan", strjson, httpOptions)
        .toPromise()
    }
  }

  async UpdateEffortStart() {
    //debugger

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let param = new EffortPlanViewInfo();

      if (this.ListEffortPlan == null || this.ListEffortPlan.length <= 0) {
        param.DeletePlanGroupId = this._ParamEffortGroupId
      } else {
        param.ListEffortPlan = this.ListEffortPlan;
      };

      let strjson = JSON.stringify(param);

      return await this.httpClient.post<boolean>(this.baseurl + "ProjectEffortPlan/UpdateEffortStart", strjson, httpOptions)
        .toPromise()
    }
  }

  async UpdateETC(id,etc) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EffortPlanId'] = id;
      objectjson['ETC'] = etc;
      
      objectjson['EffortPlanUpdateBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      // Make the HTTP POST request
      this.isSubmitted = await this.httpClient.post<EffortPlanInfo[]>(
        this.baseurl + "ProjectEffortPlan/UpdateETC",
        strjson,
        httpOptions
      ).toPromise();
      return true; // Return true if the update was successful
      console.log("Update successful:", this.isSubmitted);
      this.LoadEffortPlanDelivery();
        } else {
          return false; // Return false if the authentication token is not available
        }
    
  }

  async LoadPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<JobInfo[]>(this.baseurl + "Job/GetJob", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectEmpName = data;
          this.selectEmpName.map(o => {
            o.emp_label =
              ` ${o.EmpCode} - ${o.EmpName_TH}
          `
            return o
          });
        });

    }
  }

  //Import Plan

  async importGroupPlan() {
    if (this._ParamSaleEffortGroupId && this._ParamProjectCode) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //this.Loading(true, 'Loading...');

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['EffortGroupId'] = this._ParamSaleEffortGroupId;
        objectjson['SearchAsOfDate'] = this.txtSchYear;

        let strjson = JSON.stringify(objectjson);

        return await this.httpClient.post<any>(this.baseurl + "ProjectEffortPlan/ImportEffortProjectDelivery", strjson, httpOptions)
          .toPromise().then(data => {
            this.isImport = data.Value;
            if (this.isImport == true) { 
            // Now that you have the response data, you can proceed with other actions
            this.LoadEffortPlanDelivery().then((loadedData) => {
              this.ListEffortPlan = loadedData;
              this.ListMonth = this.getMaxMonth();

              // Iterate through ListEffortPlan
              this.ListEffortPlan.forEach((effortPlan) => {
                // Iterate through ListEffort of each EffortPlan
                effortPlan.ListEffort.forEach((effortInfo) => {
                  // Check if EffortMonthYear is missing
                  if (!effortInfo.EffortMonthYear) {
                    // Find the matching ListMonth item based on id
                    const matchingMonth = this.ListMonth.find((month) => month.id === effortInfo.EffortMonth);

                    // If a matching month is found, add EffortMonthYear
                    if (matchingMonth) {
                      effortInfo.EffortMonthYear = matchingMonth.monthYear;
                    }
                  }

                  const effortMonthYear = effortInfo.EffortMonthYear;
                  if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
                    this.minEffortMonthYear = effortMonthYear;
                  }
                });
              });

              this.UpdateEffortStart();
            });
              return true;
            }
          });
      }
    }
  }

  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if (Date.parse(startcontrol.value) > Date.parse(endcontrol.value)) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }

  checkdateActual(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if ((startcontrol.value == '' || startcontrol.value == null) && endcontrol.value != null && endcontrol.value != "") {
        startcontrol.setErrors({ needstartdate: true });
        startcontrol.markAsTouched();
        endcontrol.markAsTouched();

      } else {
        startcontrol.setErrors(null);
      }
    };
  }


  checkdatecurrent(
    controlName: string,
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];

      if (startcontrol.errors && !startcontrol.errors.checkdatecurrent) {
        return;
      }

      if (Date.parse(new Date().toDateString()) > Date.parse(startcontrol.value)) {
        startcontrol.setErrors({ checkdatecurrent: true });
      } else {
        startcontrol.setErrors(null);
      }
    };
  }

  //Calculate Actual working hours

  async LoadReport() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Initialize an array of EmpInfo objects
      this.selectEmpName = [];

      // Create and populate EmpInfo objects with EffortPlanEmpCode values
      this.ListEffortPlan.forEach(effortPlan => {
        const empInfo: EmpInfo = {
            EmpCode: effortPlan.EffortPlanEmpCode,
            Id: 0,
            EmpCodeValidate: '',
            EmpName: '',
            Username: '',
            Password: '',
            AgentId: '',
            Title_TH: '',
            Title_Name: '',
            EmpFname_TH: '',
            EmpLname_TH: '',
            EmpName_TH: '',
            EmpName_EN: '',
            Title_EN: '',
            EmpFname_EN: '',
            EmpLname_EN: '',
            EmpType: '',
            EmpTypeName: '',
            JobCode: '',
            JobTitle: '',
            CompanyCode: '',
            CompanyName: '',
            Mobile: '',
            PositionCode: 0,
            PositionName: '',
            ActiveFlag: '',
            Mail: '',
            EntryDate: '',
            UpdateDate: '',
            UpdateBy: '',
            CreateDate: '',
            CreateBy: '',
            ExpireDate: '',
            LoginEmpCode: '',
            FlagDelete: '',
            LookupValue: '',
            countEmp: 0,
            rowOFFSet: 0,
            rowFetch: 0,
            RoleCode: '',
            RoleName: '',
            DepartmentCode: '',
            UnitCode: '',
            TeamCode: '',
            TeamName: '',
            NickName: '',
            CountProjectCreateBy: 0,
            PercentProjectSalebyEmp: 0,
            IsTeam: false,
            ImgProfile: '',
            Token: '',
            RefreshToken: '',
            BirthDate: '',
            Gender: '',
            GenderName: '',
            OrganizationCode: '',
            emp_label: '',
            ResignDate: '',
            BaseArea: '',
            DivisionCode: '',
            DivisionName: '',
            lJobTitle: [],
            ProjectCode: ''
        };

        // Push the created EmpInfo object into the selectEmpName array
        this.selectEmpName.push(empInfo);
      });

      var objectjson = {};
      objectjson['SearchEmployeeCode'] = this.selectEmpName;
      objectjson['SearchAsOfDate'] = null;// this.ListEffortPlan.map(list => list.ListEffort.map(item => item.EffortMonthYear));
      objectjson['SearchFormat'] = this.checkUndefinedString(this.txtSchFormat) ? this.txtSchFormat : "1";
      objectjson['SearchProjectCode'] = this.checkUndefinedString(this._ParamProjectCode);

      console.log(this.txtSchYear)

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post < ReportEffortPlanProjectInfo[]>(this.baseurl + "ProjectEffortPlan/GetReportActualSummary",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            console.log("ReportView-->", data);
            this.ReportView = data; // Assign the object directly, not wrapped in an array

            //this.replaceCommasAll();
          },
          error: error => {
            console.error("Error:", error);
          }
        });
    }
  }


  // ---------------------- End Project Plan  Zone  -------------------------------

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }

  async onChanges(idx, loadFromModal: boolean = false) {
    
    //this.itemsSetting = this.ProjectDetailForm.get('DeliveryForm').get('items') as FormArray;

    let empcode = '';
    let empselectbox = this.itemsSetting.controls[idx].get('ContactlistEmpCode');

    if (loadFromModal) {
      empcode = this.selectedemp.EmpCode;
    } else {
      empcode = this.itemsSetting.controls[idx].get('ContactlistEmpCode').value;
    }

    var nickname = this.selectEmpName.find(x => { return x.EmpCode == empcode }).NickName;
    var mobile = this.selectEmpName.find(x => { return x.EmpCode == empcode }).Mobile;
    var mails = this.selectEmpName.find(x => { return x.EmpCode == empcode }).Mail;
    //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionCode;
    var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionName;

    var EmpNickname = this.itemsSetting.controls[idx].get('ContactlistNickName');
    var EmpPhone = this.itemsSetting.controls[idx].get('ContactlistPhone');
    var EmpMail = this.itemsSetting.controls[idx].get('ContactlistEmail');
    var EmpPosition = this.itemsSetting.controls[idx].get('ContactlistPositionName');

    EmpNickname.setValue(nickname)
    EmpPhone.setValue(mobile)
    EmpMail.setValue(mails)
    EmpPosition.setValue(positions)

    if (loadFromModal) {
      let code = this.selectEmpName.find(x => { return x.EmpCode == empcode }).EmpCode;

      empselectbox.setValue(code);
    } 
  }

  dateselect() {
    //this.employeeselectrun = true;
    this.txtSchYear = ""
    //this.selectedemp = [];
    //this.ReportView = null;
    $('#ModalSelectDate').modal();
  }

  selectedEmp(event) {
    console.log("SELECTED EMP", event)

    this.selectedemp = event[0];
    console.log(this.selectedemp)

    this.saveEmpSelect();
  }

  empselect(num) {
    this.employeeselectrun = true;
    this.employeeselectreturnto = num;
    this.selectedemp = null;
    this.rolefiltermodal = this.ListEffortPlan[num].EffortPlanRole;
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {
    if (this.selectedemp != null) {
      // Check duplicate before saving
      const isDuplicate = this.isEmpCodeDuplicate(this.selectedemp.EmpCode);

      if (!isDuplicate) {
        // hide modal Assign PM
        $('#ModalEmpSelect').modal('hide');
        this.employeeselectrun = false;

        //this.onChanges(this.employeeselectreturnto, true)
        this.ListEffortPlan[this.employeeselectreturnto].EffortPlanEmpCode = this.selectedemp.EmpCode;
        this.ListEffortPlan[this.employeeselectreturnto].EffortPlanEmpName =
          this.selectedemp.EmpFname_EN + ' ' + this.selectedemp.EmpLname_EN;

        this.selectedemp = null;
      } else {
        alert("You cannot select duplicate employee.");
      }
    } else {
      alert("Please select an employee");
    }
  }

  isEmpCodeDuplicate(empCode: string): boolean {
    return this.ListEffortPlan.some(item => item.EffortPlanEmpCode === empCode);
  }
/*  async saveEmpSelect() {

    if (this.selectedemp != null) {
      // hide modal Assign PM
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;


      //this.onChanges(this.employeeselectreturnto, true)
      this.ListEffortPlan[this.employeeselectreturnto].EffortPlanEmpCode = this.selectedemp.EmpCode;
      this.ListEffortPlan[this.employeeselectreturnto].EffortPlanEmpName = this.selectedemp.EmpFname_EN + ' ' + this.selectedemp.EmpLname_EN;

      this.selectedemp = null;

    } else {
      alert("Please select an employee")
    }

  }*/

  async saveDateSelect() {

    $('#ModalSelectDate').modal('hide');
    //debugger
    this.txtSchYear = this.txtSchYear
    this.uniqueMonth.length;
    const data = await this.importGroupPlan();
    this.btnClick_reload();
  }

  generateFormattedMonths() {
    const defaultStartDate = new Date(this.minEffortMonthYear);

    const StartDate = this.txtSchYear ? new Date(this.txtSchYear) : new Date(formatDate(defaultStartDate, 'yyyy-MMM', 'en-US'));

    for (let i = 0; i < this.uniqueMonth.length; i++) {
      const date = new Date(StartDate.getFullYear(), StartDate.getMonth() + i, 1);
      const monthYearString = this.getMonthYearString(date);
      this.ListMonth.push({ monthYear: monthYearString });
    }

    // Log the entire ListMonth array
    console.log("ListMonth:", this.ListMonth);
  }

  getMonthYearString(date: Date): string {
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${month}-${year.toString().slice(-2) }`;
  }

  getMonthYearDB(date: Date): string {
    const monthNames = [
      '01', '02', '03', '04', '05', '06',
      '07', '08', '09', '10', '11', '12'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${year}-${month}-01`;
  }

  //click func
  async btnClick_reload(keepList: boolean = false, addMonth: boolean = false) {

    let old = this.ListEffortPlan;
    console.log("old == ", old);

    this.validateDelivery = false;

    this.ListMonth = [];
    this.ListMonthSale = [];

    if(this.plancount > 0) this.txtSchYear = '';

    await this.getPlanListGroup();

    (await this.LoadTabSale().then((data) => {
      this.ListEffortPlanSale = data;
      this.ListMonthSale = this.getMaxMonthSale()
      // Iterate through ListEffortPlan
      this.ListEffortPlanSale.forEach((effortPlan) => {
        // Iterate through ListEffort of each EffortPlan
        effortPlan.ListEffort.forEach((effortInfo) => {
          // Check if EffortMonthYear is missing
          if (!effortInfo.EffortMonthYear) {
            // Find the matching ListMonth item based on id
            const matchingMonth = this.ListMonthSale.find((month) => month.id === effortInfo.EffortMonth);

            // If a matching month is found, add EffortMonthYear
            if (matchingMonth) {
              effortInfo.EffortMonthYear = matchingMonth.monthYear;
            }
          }

          const effortMonthYear = effortInfo.EffortMonthYear;
          if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
            this.minEffortMonthYear = effortMonthYear;
          }
        });
      });
    }));

    // Delivery Tab
    (await this.LoadEffortPlanDelivery().then((data) => {
      this.ListEffortPlanTransfer = data.filter(ep => ep.EffortPlanFlagActive == 'N');
      console.log("LoadEffortPlanDeliverytrans 22 === ", this.ListEffortPlanTransfer);
      console.log("LoadEffortPlanDelivery 22 === ", data.filter(r => r.EffortPlanFlagActive == "Y"));
      
      this.ListEffortPlan = data.filter(ep => ep.EffortPlanFlagActive == 'Y');
      // Iterate through ListEffortPlan
      this.ListEffortPlan.forEach((effortPlan) => {
        // Iterate through ListEffort of each EffortPlan
        effortPlan.ListEffort.forEach((effortInfo) => {
          // Check if EffortMonthYear is missing
          if (!effortInfo.EffortMonthYear) {
            // Find the matching ListMonth item based on id
            const matchingMonth = this.ListMonth.find((month) => month.id === effortInfo.EffortMonth);

            // If a matching month is found, add EffortMonthYear
            if (matchingMonth) {
              effortInfo.EffortMonthYear = matchingMonth.monthYear;
            }
          }

          const effortMonthYear = effortInfo.EffortMonthYear;
          if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
            this.minEffortMonthYear = effortMonthYear;
          }
        });
      });

      this.plancount = this.ListEffortPlan.length;
    }));

    console.log(this.ListMonth)

    this.loadEffortPlanList().then(data => {
      this.groupedPlanDataList = data;
      if (this.groupedPlanDataList.length > 0) {
        this._ParamEffortGroupName = this.groupedPlanDataList[0].EffortGroupName;
        this._ParamEffortGroupType = this.groupedPlanDataList[0].ProjectType;
        this._ParamEffortGroupId = this.groupedPlanDataList[0].EffortGroupId;

        this.ListMonth = this.getMaxMonth()

        // Iterate through ListEffortPlan
        this.ListEffortPlan.forEach((effortPlan) => {
          // Iterate through ListEffort of each EffortPlan
          effortPlan.ListEffort.forEach((effortInfo) => {
            // Check if EffortMonthYear is missing
            if (!effortInfo.EffortMonthYear) {
              // Find the matching ListMonth item based on id
              const matchingMonth = this.ListMonth.find((month) => month.id === effortInfo.EffortMonth);

              // If a matching month is found, add EffortMonthYear
              if (matchingMonth) {
                effortInfo.EffortMonthYear = matchingMonth.monthYear;
              }
            }

            const effortMonthYear = effortInfo.EffortMonthYear;
            if (!this.minEffortMonthYear || (effortMonthYear && effortMonthYear < this.minEffortMonthYear)) {
              this.minEffortMonthYear = effortMonthYear;
            }
          });
        });

      } else {
        this._ParamEffortGroupName = null;
        this._ParamEffortGroupType = null;
        this._ParamEffortGroupId = null;
      }
    });

    this.LoadPosition().then((data) => {
      this.ListPosition = data;
    });

    this.loadEmp();
    // End Delivery Tab

    await this.LoadReport();

    if (keepList) this.ListEffortPlan = old;
    if (addMonth) this.addMonthColumn();
  }

  btnClick_submit() {

    this.validateDelivery = true;

    for (var i = 0; i < this.ListEffortPlan.length; i++) {
      let projrole = this.ListEffortPlan[i].EffortPlanProjectRole
      let role = this.ListEffortPlan[i].EffortPlanRole
      let emp = this.ListEffortPlan[i].EffortPlanEmpCode

      if (projrole == null || projrole == '' || projrole == ' ') return;
      if (role == null || role == '' || role == ' ') return;
      if (emp == null || emp == '' || emp == ' ') return;
    }

    this.SaveEffortPlan().then((data) => {
      this.btnClick_reload()
    });
  }

  //misc func
  getMonthYearStringCurdate(datep) {
    const date = new Date(datep.getFullYear(), datep.getMonth(), 1);
    const monthYearString = this.getMonthYearString(date);
    return monthYearString;
  }


  getMaxMonth() {

    let maxce = 0;
    let ceil = [];
    for (let i of this.ListEffortPlan) {
      //let max = Array.from(new Set(i.ListEffort.map((item: any) => item.EffortMonth)));

      //if (max.length > ceil.length) ceil = max;

      let des = i.ListEffort.sort((a, b) => {
        return a.EffortMonth < b.EffortMonth
          ? 1
          : -1
      })

      if (des[0].EffortMonth > maxce) maxce = des[0].EffortMonth;

    }
    const defaultStartDate = new Date(this.minEffortMonthYear);

    const StartDate = this.txtSchYear ? new Date(this.txtSchYear) : new Date(formatDate(defaultStartDate, 'yyyy-MMM', 'en-US'));

    for (let v = 1; v <= maxce; v++) {
      ceil.push(v)
      const date = new Date(StartDate.getFullYear(), StartDate.getMonth() - 1 + v, 1);
      const monthYearString = this.getMonthYearString(date);
      const monthYearDB = this.getMonthYearDB(date);
      this.ListMonth.push({ id: v, monthYear: monthYearString, monthYearDB: monthYearDB });
    }

    return this.ListMonth;
  }

  getMaxMonthSale() {

    let maxce = 0;
    let ceil = [];
    for (let i of this.ListEffortPlanSale) {
      //let max = Array.from(new Set(i.ListEffort.map((item: any) => item.EffortMonth)));

      //if (max.length > ceil.length) ceil = max;

      let des = i.ListEffort.sort((a, b) => {
        return a.EffortMonth < b.EffortMonth
          ? 1
          : -1
      })

      if (des[0].EffortMonth > maxce) maxce = des[0].EffortMonth;

    }
    const defaultStartDate = new Date(this.minEffortMonthYear);

    const StartDate = this.txtSchYear ? new Date(this.txtSchYear) : new Date(formatDate(defaultStartDate, 'yyyy-MMM', 'en-US'));

    for (let v = 1; v <= maxce; v++) {
      ceil.push(v)
      const date = new Date(StartDate.getFullYear(), StartDate.getMonth() - 1 + v, 1);
      const monthYearString = this.getMonthYearString(date);
      const monthYearDB = this.getMonthYearDB(date);
      this.ListMonthSale.push({ id: v, monthYear: monthYearString, monthYearDB: monthYearDB });
    }

    return this.ListMonthSale;
  }

  addMonthColumn() {

    //debugger

    if (!this._ParamEffortGroupName && !this.txtSchYear) {
      this.dateselectProj()
      return;
    }

    const defaultStartDate = new Date(this.minEffortMonthYear);

    const StartDate = this.txtSchYear ? new Date(this.txtSchYear) : new Date(formatDate(defaultStartDate, 'yyyy-MMM', 'en-US'));

    let y = this.ListMonth.length > 0 ? Number(this.ListMonth[this.ListMonth.length - 1].id) + 1 : 1;

    const date = new Date(StartDate.getFullYear(), StartDate.getMonth() + this.ListMonth.length, 1);
    const monthYearString = this.getMonthYearString(date);
    const monthYearDB = this.getMonthYearDB(date);
    this.ListMonth.push({ id: y, monthYear: monthYearString, monthYearDB: monthYearDB });

    //this.ListMonth.push(y);
  }

  dateselectProj() {
    //this.employeeselectrun = true;
    this.txtSchYear = ""
    //this.selectedemp = [];
    //this.ReportView = null;
    $('#ModalSelectDateProj').modal();
  }

  addRoleRow() {

    //if (!this._ParamEffortGroupName && !this.txtSchYear) {
    //  this.dateselectProj()
    //  return;
    //}

    let x = new EffortPlanInfo();
    x.EffortGroupId = Number(this._ParamEffortGroupId);
    x.EffortPlanProjectRole = '';
    x.EffortPlanEmpName = '';
    x.ListEffort = [];

    for (var i = 0; i < this.ListMonth.length; i++) {
      let y = new EffortInfo();
      y.EffortMonth = this.ListMonth[i].id;
      y.EffortManDay = null;
      y.EffortMonthYear = this.ListMonth[i].monthYearDB;

      x.ListEffort.push(y)
    }

    console.log(this.ListEffortPlan)

    this.ListEffortPlan.push(x);
  }

  removeMonthColumn(index) {
    //debugger

    for (let ind in this.ListMonth) {
      if (ind > index) {
        this.ListMonth[ind].id = this.ListMonth[ind].id - 1;
        this.ListMonth[ind].monthYear = this.ListMonth[Number(ind) - 1].monthYear;
        this.ListMonth[ind].monthYearDB = this.ListMonth[Number(ind) - 1].monthYearDB;
      }
    }
    this.ListMonth.splice(index, 1);

    for (let i of this.ListEffortPlan) {

      //i.ListEffort.forEach((value, ind) => {
      //  if (ind > index) value.EffortMonth -= 1;
      //});


      let delindex = i.ListEffort.map(e => e.EffortMonth).indexOf(index + 1)

      for (let item of i.ListEffort) {
        if (item.EffortMonth > index + 1) item.EffortMonth = item.EffortMonth - 1
      }

      if (delindex > 0) i.ListEffort.splice(delindex, 1);
    }

  }

  removeRoleRow(index) {
    this.ListEffortPlan.splice(index, 1);
  }


  getEmployeeWorkhoursByMonth(EmployeeIndex: string, MonthSeq: string) {

    //debugger

    let res = ''

    if (this.ListEffortPlan[EmployeeIndex].ListEffort == null || this.ListEffortPlan[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlan[EmployeeIndex].ListEffort.filter(x => x.EffortMonth == MonthSeq);

    if (rec != null && rec.length > 0) res = rec[0].EffortManDay;

    return res;
  }

  getEmployeeWorkhoursTotal(EmployeeIndex: string) {

    //debugger

    let res = 0

    if (this.ListEffortPlan[EmployeeIndex].ListEffort == null || this.ListEffortPlan[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlan[EmployeeIndex].ListEffort;

    if (rec != null && rec.length > 0) res = rec.reduce((sum, current) => sum + current.EffortManDay, 0);

    return res;
  }

  getEmployeeWorkhoursByMonthTotal(MonthSeq: string) {

    //debugger

    let rec = 0;

    for (let i of this.ListEffortPlan) {

      let x = i.ListEffort.filter(x => x.EffortMonth == Number(MonthSeq))

      if (x != null && x.length > 0) rec += x[0].EffortManDay;

    }

    return rec;
  }

  getEmployeeWorkhoursAllTotal() {

    let total = 0;

    if (this.ListEffortPlan == null || this.ListEffortPlan.length <= 0) return total;

    for (let i of this.ListEffortPlan) {
      let hours = i.ListEffort != null && i.ListEffort.length > 0 ? i.ListEffort.reduce((sum, current) => sum + current.EffortManDay, 0) : 0;

      total += hours;
    }

    return total;
  }

  getSaleWorkhoursByMonth(EmployeeIndex: string, MonthSeq: string) {

    //debugger

    let res = ''

    if (this.ListEffortPlanSale[EmployeeIndex].ListEffort == null || this.ListEffortPlanSale[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlanSale[EmployeeIndex].ListEffort.filter(x => x.EffortMonth == MonthSeq);

    if (rec != null && rec.length > 0) res = rec[0].EffortManDay;

    return res;
  }

  getHistorySaleWorkhoursByMonth(empCode: string, EmployeeIndex: string, MonthSeq: string) {
    let res = ''

    if (this.ListEffortPlanTransfer[EmployeeIndex].ListEffort == null || this.ListEffortPlanTransfer[EmployeeIndex].ListEffort.length <= 0) return res;

    // console.log("EmployeeIndex == " , this.ListEffortPlanTransfer[EmployeeIndex]);

    let rec = this.ListEffortPlanTransfer[EmployeeIndex].ListEffort.filter(x => x.EffortMonth == MonthSeq);

    if (rec != null && rec.length > 0) res = rec[0].EffortManDay;

    return res;
  }

  getSaleWorkhoursTotal(EmployeeIndex: string) {

    let res = 0

    if (this.ListEffortPlanSale[EmployeeIndex].ListEffort == null || this.ListEffortPlanSale[EmployeeIndex].ListEffort.length <= 0) return res;

    let rec = this.ListEffortPlanSale[EmployeeIndex].ListEffort;

    if (rec != null && rec.length > 0) res = rec.reduce((sum, current) => sum + current.EffortManDay, 0);

    return this.replaceCommas(res);
  }

  getSaleWorkhoursByMonthTotal(MonthSeq: string) {

    //debugger

    let rec = 0;

    for (let i of this.ListEffortPlanSale) {

      let x = i.ListEffort.filter(x => x.EffortMonth == Number(MonthSeq))

      if (x != null && x.length > 0) rec += x[0].EffortManDay;

    }

    return rec;
  }

  getSaleWorkhoursAllTotal() {

    let total = 0;

    for (let i of this.ListEffortPlanSale) {
      let hours = i.ListEffort.length > 0 ? i.ListEffort.reduce((sum, current) => sum + current.EffortManDay, 0) : 0;

      total += hours;
    }

    return this.replaceCommas(total);
  }

  inputChange(EmpIndex, MonthSeq, Value) {

    //debugger

    if (this.ListEffortPlan[EmpIndex].ListEffort == null || this.ListEffortPlan[EmpIndex].ListEffort.length <= 0) {

      let lx = [];
      let x = new EffortInfo();
      x.EffortMonth = Number(MonthSeq);
      x.EffortManDay = Number(Value);
      x.EffortMonthYear = this.ListMonth[MonthSeq - 1].monthYearDB;

      lx.push(x)

      this.ListEffortPlan[EmpIndex].ListEffort = lx;
    } else {

      let rec = this.ListEffortPlan[EmpIndex].ListEffort.filter(x => x.EffortMonth == MonthSeq);
      if (rec == null || rec.length <= 0) {
        // let max = Array.from(new Set(this.ListEffortPlan[EmpIndex].ListEffort.map((item: any) => item.EffortMonth))).length;
        let x = new EffortInfo();
        x.EffortMonth = Number(MonthSeq);
        x.EffortManDay = (Value != '') ? Number(Value) : null;
        x.EffortMonthYear = (MonthSeq != '') ? this.ListMonth[MonthSeq - 1].monthYearDB : null;
        this.ListEffortPlan[EmpIndex].ListEffort.push(x);

        this.ListEffortPlan[EmpIndex].ListEffort.sort((a, b) => {
          return a.EffortMonth >= b.EffortMonth
            ? 1
            : -1
        })

      } else {
        rec[0].EffortManDay = (Value != '') ? Number(Value) : null;
      }

    };

    console.log(this.ListEffortPlan)
    this.valuechanged()
  }

  inputProjectRoleChange(EmpIndex, Value) {
    this.ListEffortPlan[EmpIndex].EffortPlanProjectRole = Value
    this.valuechanged()
  }

  inputRoleChange(EmpIndex, Value) {
    this.ListEffortPlan[EmpIndex].EffortPlanRole = Value
    this.valuechanged()
  }

  inputEmpChange(EmpIndex, Value) {
    // Check for duplicate before updating the value
    const isDuplicate = this.isEmpCodeDuplicate(Value);

    if (!isDuplicate) {
      this.ListEffortPlan[EmpIndex].EffortPlanEmpCode = Value;
      this.ListEffortPlan[EmpIndex].EffortPlanEmpName = Value;
      this.valuechanged();
    } else {
      alert("You cannot select duplicate employee.");
    }
  }

/*  inputEmpChange(EmpIndex, Value) {
    this.ListEffortPlan[EmpIndex].EffortPlanEmpCode = Value
    this.ListEffortPlan[EmpIndex].EffortPlanEmpName = Value
    this.valuechanged()
  }*/

  renderComponent() {
    this.reload = false;
    this.cdr.detectChanges();
    this.reload = true;
  }

  valuechanged() {
    this.valuechange = true;
  }

  //Calculate Actual Tab

  getActualEmployeeWorkhoursByMonth(PlanIndex: string, EmpIndex: string, MonthSeq: string) {

    //debugger

    let rec = 0;

    // Extract the Year-Month portion of the strings
    const yearMonth = MonthSeq.substring(0, 7);

    let x = this.ReportView.filter(x => x.EmployeeCode == EmpIndex && x.TimeSheetDate.substring(0, 7) == yearMonth);


    if (x != null && x.length > 0) {
      for (let i = 0; i < x.length; i++) { 
        rec += x[i].Hours;
      }

    }
    return rec;
  }

 getActualEmployeeWorkhoursTotal(PlanIndex: string) {

    let res = 0;

    if (this.ListEffortPlan[PlanIndex].ListEffort == null || this.ListEffortPlan[PlanIndex].ListEffort.length <= 0) {
      return res;
    }

    const rec = this.ListEffortPlan[PlanIndex].ListEffort;

    //for (let r of rec) {
      for (let mth of this.ListMonth) {
        const workHoursTotal = this.getActualEmployeeWorkhoursByMonth(PlanIndex.toString(), this.ListEffortPlan[PlanIndex].EffortPlanEmpCode, mth.monthYearDB);
        res += workHoursTotal;
      }
    //}

    return res;
  }
  private processedEffortPlanIds = new Set<number>();

  getActualEmployeeWorkhoursTotalETC(PlanIndex: string, selectedValue: number) {



    //debugger

    console.log('List effort plan')
    console.log(this.ListEffortPlan)

    let res: number = 0;
    let x: number = 0;
    const effortPlan = this.ListEffortPlan[PlanIndex];
    this.selectedETC = (selectedValue) ? String(selectedValue) : String(0);
    for (let mth of this.ListMonth) {
      const workHoursTotal = this.getActualEmployeeWorkhoursByMonth(PlanIndex.toString(), this.ListEffortPlan[PlanIndex].EffortPlanEmpCode, mth.monthYearDB);
      res += workHoursTotal;
    }

    if (effortPlan.EffortPlanId) {
      // Check if it's EffortPlanId or ListEffort
      if (Number(selectedValue) != 0 && selectedValue.toString() != "") {
        // It's EffortPlanId, you can process it here
        console.log('EffortPlanId:', effortPlan.EffortPlanId);

        // Attempt to update ETC asynchronously
        return this.UpdateETC(Number(effortPlan.EffortPlanId), Number(selectedValue))
          .then((result) => {
            if (result === true) {
              // Mark the EffortPlanId as processed
              this.processedEffortPlanIds.add(effortPlan.EffortPlanId);
              return x = res + Number(selectedValue);
            }
          })
          .catch((error) => {
            console.error("Update ETC failed:", error);
            throw error; // Rethrow the error to be caught by the caller
          });
      }


      return x = res + Number(selectedValue); // Return x immediately if the EffortPlanId has been processed
    }
  }
 

  //getActualEmployeeWorkhoursTotalETC(PlanIndex: number, selectedValue: number) {
  //  let res: number = 0;
  //  let x: number = 0;
  //  this.selectedETC = (selectedValue) ? selectedValue : 0;

  //  for (let mth of this.ListMonth) {
  //      const workHoursTotal = this.getActualEmployeeWorkhoursByMonth(PlanIndex.toString(), this.ListEffortPlan[PlanIndex].EffortPlanEmpCode, mth.monthYearDB);
  //    res += workHoursTotal;
  //  }
  //  x = res + Number(selectedValue);
  //  if (selectedValue != 0) {
  //    this.UpdateETC(this.ListEffortPlan[PlanIndex].EffortPlanId, Number(selectedValue))
  //      .then((result) => {
  //        if (result === true) {
  //          return x;
  //        }
  //      })
  //      .catch((error) => {
  //        console.error("Update ETC failed:", error);
  //      });
  //  } else {
  //    return x; // Return x immediately if selectedValue is 0
  //  }
  //}

  getActualEmployeeWorkhoursByMonthTotal(MonthSeq: string) {

    let rec = 0;

    // Extract the Year-Month portion of the input MonthSeq
    const yearMonth = MonthSeq.substring(0, 7);

    // Loop through the ListEffortPlan
    for (let i = 0; i < this.ListEffortPlan.length; i++) {
      const empCode = this.ListEffortPlan[i].EffortPlanEmpCode;

      // Filter ReportView based on EmployeeCode and Year-Month
      const filteredRecords = this.ReportView.filter(x => x.EmployeeCode === empCode && x.TimeSheetDate.substring(0, 7) === yearMonth);

      // Sum the Hours from the filtered records
      if (filteredRecords && filteredRecords.length > 0) {
        for (let j = 0; j < filteredRecords.length; j++) {
          rec += filteredRecords[j].Hours;
        }
      }
    }

    return rec;
  }

  getActualEmployeeWorkhoursAllTotal() {

    let rec = 0;

    // Loop through the ListEffortPlan
    for (let i = 0; i < this.ListEffortPlan.length; i++) {
      const empCode = this.ListEffortPlan[i].EffortPlanEmpCode;

      // Filter ReportView based on EmployeeCode and Year-Month
      const filteredRecords = this.ReportView.filter(x => x.EmployeeCode === empCode);

      // Sum the Hours from the filtered records
      if (filteredRecords && filteredRecords.length > 0) {
        for (let j = 0; j < filteredRecords.length; j++) {
          rec += filteredRecords[j].Hours;
        }
      }
    }

    return rec;
  }

  // Delivery transfer
  transferEmployeeBtnClick(){
    console.log("transferEmployeeBtnClick()..", this.ListEffortPlan);

    this.transferEmp = true;
    this.transferEmpSelectStep = false;
    this.transferEmpConfirmStep = false;
    $('#ModalTransferEmp').modal();



  }

  async confirmTransferEmployeeBtnClick(){
    console.log("confirmTransferEmployeeBtnClick()..");

    this.employeeselectrun = false;
    this.transferEmpConfirmStep = false;

      // Save to API
    var auth_token = await this.TokenService.RefreshToken();  
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };  
    console.log("current = ", this.effortPlanCurrent);
    console.log("to = ", this.selectedemp);

    let param = new EffortPlanTransferInfo();
    param.CurrentEffortPlan = this.effortPlanCurrent;

    let toeffortPlan = new EffortPlanInfo();
    // ไม่ต้องสร้าง EffortPlanId
    toeffortPlan.EffortGroupId = this.effortPlanCurrent.EffortGroupId;
    toeffortPlan.EffortPlanProjectRole = this.effortPlanCurrent.EffortPlanProjectRole;
    toeffortPlan.EffortPlanRoleName = this.effortPlanCurrent.EffortPlanRoleName;
    toeffortPlan.EffortPlanRole = this.effortPlanCurrent.EffortPlanRole;
    toeffortPlan.EffortPlanEmpName = this.selectedemp.EmpName_EN;
    toeffortPlan.EffortPlanEmpCode = this.selectedemp.EmpCode;
    toeffortPlan.ProjectSaleCode = this.effortPlanCurrent.ProjectSaleCode;
    toeffortPlan.ProjectSaleName = this.effortPlanCurrent.ProjectSaleName;
    toeffortPlan.ProjectType = this.effortPlanCurrent.ProjectType;
    toeffortPlan.CompanyName = this.effortPlanCurrent.CompanyName;


    let listEffort = [];
    if(this.effortPlanCurrent.ListEffort.length > 0){
      for(let i=0; i< this.effortPlanCurrent.ListEffort.length; i++){
        let effInfo = new EffortInfo();
        effInfo = this.effortPlanCurrent.ListEffort[i];
        effInfo.EffortId = null;
        listEffort.push(effInfo);
      }

    } 
    toeffortPlan.ListEffort = listEffort;

    param.ToEffortPlan = toeffortPlan;


    let strjson = JSON.stringify(param);
    console.log("strjson === ", strjson);

    $('#ModalTransferEmp').modal('hide');
    // $('#ModalTransferEmp').hide(); 

    this.effortPlanCurrent = null;    
    this.selectedemp = null;   
    // return null;

      let res = await this.httpClient.post<boolean>(this.baseurl + "EffortGroup/TransferEffortPlan", strjson, httpOptions)
        .toPromise()

      console.log("res === ", res);  

      if(res){
        this.btnClick_reload();
      }  


    }
        
  }
  

  toSelectedEmployee(eff: EffortPlanInfo){
    console.log(eff);

    if(eff){
      this.transferEmp = false;
      this.transferEmpSelectStep = true;
      this.effortPlanCurrent = eff;
    }

    //  $('#ModalTransferEmp').hide();
    // this.employeeselectrun = true;
    // $('#ModalEmpSelect').modal();

  }

   selectedEmpToTransfer(event){
      console.log("selectedEmpToTransfer", event, this.effortPlanCurrent);
      this.selectedemp = event[0]; 
      if (this.selectedemp != null) {
      // Check duplicate before saving
      const isDuplicate = this.isEmpCodeDuplicate(this.selectedemp.EmpCode);

      if (!isDuplicate) {
        // this.employeeselectrun = false;
        this.transferEmp = false;
        this.transferEmpSelectStep = false;
        this.transferEmpConfirmStep = true; 


      }else{
          alert("You cannot select duplicate employee.");
      }
    }

      

  }

  viewListEffortPlanTransfer(){
    this.viewTransferHistory = true;
  }

  closeViewListEffortPlanTransfer(){
    this.viewTransferHistory = false;
  }
  


  replaceCommas(number) {
    var result = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //if (result.indexOf('.') < 0) {
    //  result += ".00";
    //}

    return result;
  }

  removeCommas(number) {
    var result = number.toString().replace(/,/g, '');

    return result;
  }

  replaceCommasAll() {

    for (var i = 0; i < this.ListEffortPlan.length; i++) {
      this.ListEffortPlan[i].ETC = Number(this.ListEffortPlan[i].ETC)
    }
  }



}
